import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, TextInput } from "ui";

import { useAppDispatch, useAppSelector } from "store";
import { registerFormFields, registerSchema } from "../schema";
import { useRegister } from "../api/register";
import {
  setToken,
  setUserID,
  setUserState,
} from "../../layouts/dashboard-layout/slice";

export const RegisterForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const form = useForm<registerFormFields>({
    resolver: zodResolver(registerSchema),
  });
  const { register, formState, handleSubmit } = form;
  const { mutate, isLoading } = useRegister({});
  const submitHandler: SubmitHandler<registerFormFields> = (
    values: registerFormFields
  ) => {
    mutate(
      {
        data: values,
      },
      {
        onSuccess: ({ data }) => {
          dispatch(setUserID(data.data?.id));
          dispatch(setToken(data.data?.jwToken));
          dispatch(setUserState(data.data?.status));
          navigate("/authentication");
        },
      }
    );
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <TextInput
        label={"تلفن همراه"}
        error={formState.errors.phoneNumber?.message}
        registration={register("phoneNumber")}
        placeholder={"نام کاربری  خود را وارد کنید"}
        isRequired
      />
      <TextInput
        label={"نام"}
        error={formState.errors.firstName?.message}
        registration={register("firstName")}
        placeholder={"نام خود را وارد کنید"}
        isRequired
      />
      <TextInput
        label={"نام خانوادگی "}
        error={formState.errors.lastName?.message}
        registration={register("lastName")}
        placeholder={"نام خانوادگی  خود را وارد کنید"}
        isRequired
      />
      <TextInput
        label={"ایمیل"}
        error={formState.errors.email?.message}
        registration={register("email")}
        placeholder={"ایمیل  خود را وارد کنید"}
        isRequired
      />
      <Button
        isLoading={isLoading}
        isDisabled={isLoading}
        className="btn btn-primary my-2 w-100"
        type="submit"
        onClick={handleSubmit(submitHandler)}
      >
        ورود
      </Button>
    </form>
  );
};
